import { useHotkeys } from 'react-hotkeys-hook';

// One hook per chord: react-hotkeys-hook shares one sequence buffer across a call's keys.
export const Chord = ({
  hotkey,
  onPress,
  inFields = false,
}: {
  hotkey: string;
  onPress: () => void;
  inFields?: boolean;
}) => {
  useHotkeys(
    hotkey,
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!inFields && target?.closest('[role="dialog"], [role="menu"]')) return;
      event.preventDefault();
      onPress();
    },
    { enableOnFormTags: inFields, enableOnContentEditable: inFields },
  );
  return null;
};
